import Glide, {
	Controls,
	Breakpoints,
	Autoplay,
	Swipe,
} from '@glidejs/glide/dist/glide.modular.esm';
import _, { forEach } from 'lodash';

const Availabilities = {
	init() {
		function getQueryVariable(variable) {
			var query = window.location.search.substring(1);
			var vars = query.split('&');
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=');
				if (decodeURIComponent(pair[0]) == variable) {
					return decodeURIComponent(pair[1]);
				}
			}
			//console.log('Query variable %s not found', variable);
		}
		const floorplanslider = document.getElementById('floorplan-slider');
		let active_date = getQueryVariable('availability');
		let _affordable = getQueryVariable('affordable');
		var region_property_found = false;
		var glide = new Glide('.glide').destroy();
		let window_width =
			window.innerWidth ||
			document.documentElement.clientWidth ||
			document.body.clientWidth;
		let margin = window_width / 10;
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			maximumFractionDigits: 0,
		});
		if (floorplanslider) {
			let _properties = [];
			let isAffordable = _tier == 'Affordable' ? true : false;

			_properties = properties.filter((property) => {
				let included = false;
				availability_ids.forEach((id) => {
					const _arr = property.affordable;
					if (_arr.length) {
						if (_arr.includes(id)) {
							included = true;
						}
					}
				});
				if(availability_ids == ''){
					const previousChildren =
								document.getElementById('floorplan-slider');
					previousChildren.style.display = 'none';
					previousChildren.previousElementSibling.style.display =
						'none';
				}
				return availability_ids.includes(property.post_id) || included;
			});

			if (_properties.length > 0) {
				let _count = 0;
				let floorplan_directory_name = '';

				const postContainer = document.getElementById('cards-grid');
				const buttonsContainer =
					document.getElementById('glide__bullets');

				var glide;
				async function loadPosts(prop) {
					let _today = '';
					const date = new Date();
					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const day = String(date.getDate()).padStart(2, '0');

					_today = `${year}-${month}-${day}`;

					if (active_date) {
						_today = active_date;
					}
					try {
						let $query = `?propertyId[]=${prop.parentId}&has_availability=true&order=DESC`;
						if (isAffordable || _affordable) {
							$query = `?propertyId=${prop.parentId}&affordable=true&order=DESC&availability=${_today}`;
						}
						let _url =
							home_url +
							`/wp-json/middleware/v1/getFloorplans/${$query}`;
						const response = await fetch(_url);
						if (!response.ok) {
							throw new Error(
								'Network response was not ok ' +
									response.statusText
							);
						}
						const posts = await response.json();
						// Check if there are posts

						if (posts.length === 0) {
							loadMoreButton.style.display = 'none';
							const postElement = document.createElement('div');
							postElement.className = 'empty';
							postElement.innerHTML = `<div style="margin: 100px 0;text-align:center;"><h2 style="margin-bottom:10px;">No results found.</h2><p>Try another date or adjust your search criteria above.</p></div>`;
							postContainer.appendChild(postElement);
							return;
						}
						if (posts.length >= 4) {
							posts.length = 4;
						}
						if (posts.code != 'no_floorplans') {
							for (const post of posts) {
								if (parseInt(post.min_price) != 1) {
									region_property_found = true;
									const postElement =
										document.createElement('div');
									let unittype = textJSON.studio;
									if (post.beds == 1) {
										unittype = '1 '+textJSON.bedroom;
									} else if (post.beds == 2) {
										unittype = '2 '+textJSON.bedroom;
									} else if (post.beds == 3) {
										unittype = '3 '+textJSON.bedroom;
									} else if (post.beds == 4) {
										unittype = '4 '+textJSON.bedroom;
									}
									let availabilityURL = '';
									// if (post.availabilityURL) {
									// 	availabilityURL = post.availabilityURL;
									// } else {
									// }
									let tail = '';
									if (isAffordable) {
										tail = '&affordable=true';
									}
									var lang = document.querySelector("html").getAttribute("lang");
									if(lang == "en-US" || lang == "en"){
										availabilityURL = '/availabilities/?propertyId[]=';
									} else {
										if (lang == "es"){
											availabilityURL = '/es/availabilities/?propertyId[]=';
										} else if (lang == "fr"){
											availabilityURL = '/fr/availabilities/?propertyId[]=';
										} else if (lang == "zh-CN"){
											availabilityURL = '/zh-CN/availabilities/?propertyId[]=';
										} else {
											availabilityURL = '/availabilities/?propertyId[]=';
										}
									}
									availabilityURL = availabilityURL + prop.parentId + '&floorplanId=' + post.floorplanId + tail;

									// availabilityURL =
									// 	'/availabilities/?propertyId=' +
									// 	prop.propertyId;

									var link = availabilityURL;
									var link_html = '';
									var count_html = '';
									var price_html = '';
									var classname = '';
									if (parseInt(post.min_price) == 1) {
										link_html = `<button class="little-blue"  aria-label="Availability"> <a href="${link}">` + textJSON.call_for_pricing + `</a></button>`;
										classname = 'no_units';
									} else if (parseInt(post.min_price) > 0) {
										if(post.min_price == post.max_price) {
											price_html =`<div class="label"><small>` + textJSON.rent_range + `</small></div>
		                            <div class="value">${formatter.format(post.min_price)}</div>`;
										}
										else {
											price_html = `<div class="label"><small>` + textJSON.rent_range + `</small></div>
										<div class="value">${formatter.format(post.min_price)} – ${formatter.format(post.max_price)}</div>`;
										}
										link_html = `<div class="label"><small>` + textJSON.available_apartments + `</small></div>
		                            <div class="value">${post.unitsCount}</div><button class="little-blue"  aria-label="Availability"> <a href="${link}">` + textJSON.view_availability + `</a></button>`;
									}
									// if(post.unitsCount > 0){
									//   count_html = `<div class="label"><small>` + textJSON.available_apartments + `</small></div>
									// <div class="value">${post.unitsCount}</div>`;
									//   link_html = '` + textJSON.view_availability + `';
									// }else{
									//   link_html = 'Call for Pricing';
									//   link = home_url + '/property/'+ post.post_slug + '#contact';
									//   classname = 'no_units';
									// }
									let _special_text = '';
									if (post.hasSpecials == 1) {
										_special_text = '<div class="is-special">'+textJSON.special_offer+'</div>';
									}
									postElement.className = 'card-item';
									postElement.innerHTML = `
									${_special_text}
		              <div class="details">
		              <p><strong><small>${prop.propertyName}</small></strong></p>
		              <h3>${unittype} ${post.floorplanName}</h3>
		              <div class="card-cols ${classname}">
		                          <div class="card-col">${price_html}
		                            <button class="arrow-button" style="display:none;" aria-label="Go to Property"> <a href="${home_url}/property/${prop.post_slug}/">
		                                ` + textJSON.virtual_tour + ` </a></button>
										${post.peek_tour ? `
											<button class="arrow-button" aria-label="Property"> 
												<a data-tour="${post.peek_tour}" href="javascript:void(0);" class="fp-tour">
												` + textJSON.virtual_tour + ` </a>
											</button>` : ''}
		                                </div>
		                                 <div class="card-col">${link_html}
		                          </div>
		                        </div>`;

									const buttonsElement =
										document.createElement('button');
									buttonsElement.className = 'glide__bullet';
									var go = '=' + _count;
									buttonsElement.setAttribute(
										'data-glide-dir',
										go
									);

									buttonsContainer.appendChild(
										buttonsElement
									);
									postContainer.appendChild(postElement);
									_count++;

									var img = new Image();
									img.onload = function () {
										this.classList.add('image');
										//const _image = postContainer.querySelector('#image-' + post.post_id);
										postElement.prepend(this);
									};
									img.addEventListener(
										'error',
										function (er) {
											this.src =
												home_url +
												'/wp-content/uploads/2024/06/coming-soon-floorplan.jpg';
											console.error(
												'Failed to load image:',
												er
											);
										}
									);
									let directory_name = prop.post_slug;

									if (floorplan_directory_name) {
										directory_name =
											post.floorplan_directory_name;
									}
									if (post.floorplanImageURL) {
										img.src = post.floorplanImageURL;
									} else {
										let fpname = post.floorplanName.replace(
											/\s/g,
											'-'
										);
										fpname = fpname.replace('/', '');
										var jpeg_url =
											home_url +
											'/wp-content/floorplans/' +
											directory_name +
											'/' +
											prop.post_slug +
											'-' +
											fpname +
											'.jpg';
										img.src = jpeg_url;
									}
								}
							}
						} else {
							const previousChildren =
								document.getElementById('floorplan-slider');
							previousChildren.style.display = 'none';
							previousChildren.previousElementSibling.style.display =
								'none';
						}
					} catch (error) {
						console.error('Failed to load posts:', error);
						floorplanslider.style.display = 'none';
						floorplanslider.previousElementSibling.style.display =
							'none';
						// if (
						// 	floorplanslider.previousElementSibling.previousElementSibling.classList.contains(
						// 		'wp-block-spacer'
						// 	)
						// ) {
						// 	floorplanslider.previousElementSibling.previousElementSibling.style.display =
						// 		'none';
						// }
					}
				}

				// Load  posts
				var count = 1;
				function buildSlider(element) {
					const window_width =
						window.innerWidth ||
						document.documentElement.clientWidth ||
						document.body.clientWidth;
					const margin = window_width / 10;
					let glide = new Glide(element, {
						hoverpause: false,
						type: 'slider',
						perView: 2,
						autoplay: false,
						bound: true,
						animationDuration: 700,
						dragThreshold: 0,
						gap: 60,
						animationTimingFunc:
							'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
						peek: {
							before: margin,
							after: margin + margin,
						},
						breakpoints: {
							1200: {
								perView: 2,
								gap: 20,
								dragThreshold: 120,
								peek: {
									before: '20px',
									after: '60px',
								},
							},
							820: {
								perView: 1,
								gap: 20,
								dragThreshold: 120,
								peek: {
									before: '20px',
									after: '60px',
								},
							},
						},
					});
					return glide;
				}
				forEach(_properties, (property, index) => {
					loadPosts(property).then(() => {
						if (!region_property_found) {
							const previousChildren =
								document.getElementById('floorplan-slider');
							previousChildren.style.display = 'none';
							previousChildren.previousElementSibling.style.display =
								'none';
							Array.from(
								document.querySelectorAll(
									'.single-location #floorplan-slider'
								)
							).forEach(function (button) {
								button.style.display = 'none';
							});
							Array.from(
								document.querySelectorAll(
									'.single-location .region_avail_slider'
								)
							).forEach(function (button) {
								button.style.display = 'none';
							});
						} else {
							const previousChildren =
								document.getElementById('floorplan-slider');
							previousChildren.style.display = 'block';
							previousChildren.previousElementSibling.style.display =
								'block';
							Array.from(
								document.querySelectorAll(
									'.single-location #floorplan-slider'
								)
							).forEach(function (button) {
								button.style.display = 'block';
							});
							Array.from(
								document.querySelectorAll(
									'.single-location .region_avail_slider'
								)
							).forEach(function (button) {
								button.style.display = 'block';
							});
						}
						if (count == _properties.length) {
							const floorplanglide =
								document.querySelector('.floorplan-glide');
							glide = buildSlider(floorplanglide);
							glide.mount({
								Controls,
								Breakpoints,
								Autoplay,
								Swipe,
							});
							window.addEventListener('resize', () => {
								setTimeout(() => {
									const floorplanglide =
										document.querySelector(
											'.floorplan-glide'
										);
									glide = buildSlider(floorplanglide);
									glide.mount({
										Controls,
										Breakpoints,
										Autoplay,
										Swipe,
									});
								}, 500);
							});
						}
						count++;
					});
				});
			}
		}
	},
};

export default Availabilities;
